export const developerApplicationStatus = {
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  DOCUMENT_REQUESTED: 'DOCUMENT_REQUESTED',
  HOLD: 'HOLD',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
};

export enum ClientAccount {
  CHICAGOREBUILD = 'CHICAGOREBUILD',
  AZIZCORP = 'AZIZCORP',
  EQUITYINACTION = 'EQUITYINACTION',
  LETS_BUILD_ACCELERATOR = 'LETSBUILDACCELERATOR',
}
